import { Cart, CartItemInterface, Maybe } from '@pylot-data/pylotschema'

const totalQty = (items?: Maybe<Maybe<CartItemInterface>[]>): number => {
    if (!items || items.length === 0) {
        return 0
    }
    let qty = 0
    items.forEach((item) => (qty += item?.quantity ?? 1))
    return qty
}

export const getQtyChange = (newState?: Cart, oldState?: Cart): number => {
    if (!oldState || !newState) {
        return 0
    }
    return totalQty(newState['items']) - totalQty(oldState['items'])
}

export const identifyCartOperationName = (
    newState?: Cart,
    oldState?: Cart
): string => {
    // Loading cart on the first time/login/logout
    if (!oldState || !newState || oldState?.email !== newState?.email) {
        return 'CART_STATE'
    }
    const qtyChange = getQtyChange(newState, oldState)
    if (qtyChange === 0) {
        return 'CART_STATE'
    }
    return qtyChange > 0 ? 'ADD_TO_CART' : 'REMOVE_FROM_CART'
}
